export default __webpack_public_path__ + "static/img_2_1-8c0f4031a2b2fed94cb58663fa0fa214.webp";